import React, { useEffect, useState } from "react";
import "./Stashboard.scss";
import { B2, H2 } from "../../ui/Typography";
import { EllipsisH, Pause, Play, WarningIcon } from "../../ui/icons";
import { ButtonWithIcon, VideoPlayer } from "../../ui";
import Loading from "../../components/Loading";
/* api calls */
import { useDispatch, useSelector } from "react-redux";
import { fetchCameraList } from "../../redux/reducers/CameraReducer";
/* end api calls */
/* images */
import live1 from "../../assets/images/live-image.png";
import live2 from "../../assets/images/live-image-2.png";
import live3 from "../../assets/images/live-image-3.png";
import live4 from "../../assets/images/live-image-4.png";
/* end images */
import axios from "axios";

function Stashboard() {
  const [isPlaying, setIsPlaying] = useState(false);
  /*api calls logic*/
  /*  const [cameraData, setCameraData] = useState(null);
  const [error, setError] = useState(null);

useEffect(() => {
  const fetchCameraList = async () => {
    try {
      const response = await fetch(
        "https://www.seedvms.com/techweb/VMS_API_USER_GETCAMERALIST",
        {
          method: "post",  // Changed to POST
          headers: {
            "Content-Type": "application/json",
            "API_KEY": "7VycsHfrj00FU7SMEsuypv1YLo0U8fBE"
          },
          body: JSON.stringify({
            UserID: "e919848e-43c8-4339-8a58-87716a288d66"
          })
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setCameraData(data);
    } catch (err) {
      console.error("API Error:", err);
      setError(err.message || "Something went wrong");
    }
  };

  fetchCameraList();
}, []);

  if (error) return <p>❌ Error: {JSON.stringify(error)}</p>;
  if (!cameraData) return <p>⏳ Loading cameras...</p>;

  if (cameraData.API_CODE === 202) {
    return <p>⚠️ {cameraData.API_MSG}</p>;
  } */

  const dispatch = useDispatch();
  const { cameras, loading, error } = useSelector((state) => state.camera);
  const [showLoading, setShowLoading] = useState(true);
  const userId = "e919848e-43c8-4339-8a58-87716a288d66";

  /* useEffect(() => {
    dispatch(fetchCameraList(userId));
  }, [dispatch, userId]); */
  useEffect(() => {
    const MIN_LOADING_TIME = 1000; // 1 second
    const start = Date.now();

    const fetchData = async () => {
      await dispatch(fetchCameraList(userId));
      const elapsed = Date.now() - start;
      const remainingTime = MIN_LOADING_TIME - elapsed;
      if (remainingTime > 0) {
        setTimeout(() => setShowLoading(false), remainingTime);
      } else {
        setShowLoading(false);
      }
    };

    fetchData();
  }, [dispatch, userId]);

  if (loading || showLoading) return <Loading title="Loading Cameras..." />;
  if (error) return <p>Error: {error}</p>;
  /*end api calls logic */

  const togglePlayPause = () => {
    setIsPlaying((prev) => !prev);
  };
  return (
    <div className="stashBoard-wrapper shadow-bottom">
      <div className="stashBoard-container">
        <ul className="stashBoard-list grid-parent">
          {Array.isArray(cameras) && cameras.length > 0 ? (
            cameras.map((camera, index) => (
              <li className="stashBoard-list-link grid-md-3" key={index}>
                <div className="video-box">
                  <iframe
                    src={camera.Camera_URL}
                    title={`Camera-${index}`}
                    className="live-stream"
                    width="100%"
                    height="300"
                    style={{
                      border: "none",
                      borderRadius: "0",
                      marginTop: "0",
                    }}
                    allowFullScreen
                  ></iframe>

                  <VideoPlayer
                    src={camera.Camera_URL}
                    isPlaying={isPlaying}
                    onPlayPause={setIsPlaying}
                  />
                  {/* <img src={live1} className="live-stream" alt="live streams" /> */}
                  <div className="video-box-controller">
                    <div className="live-badge">Live</div>
                    <B2 className="live-video-id">{camera.Camera_Stream}</B2>
                    <ButtonWithIcon
                      icon={EllipsisH}
                      className="live-video-hamburger"
                      size="sm"
                    />
                    <ButtonWithIcon
                      playPause
                      className="live-video-controller"
                      size="md"
                      onClick={togglePlayPause}
                    />
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li className="no-data-found">
              <WarningIcon size="lg" className="icon" />
              <H2 className="title">No camera available.</H2>
            </li>
          )}
          {/* <li className="stashBoard-list-link grid-md-3">
            <div className="video-box">
              <img src={live2} className="live-stream" alt="live streams" />
              <div className="video-box-controller">
                <div className="live-badge">Live</div>
                <B2 className="live-video-id">CM-PNTC/4F/40-2212</B2>
                <ButtonWithIcon
                  icon={EllipsisH}
                  className="live-video-hamburger"
                  size="sm"
                />
                <ButtonWithIcon
                  playPause
                  className="live-video-controller"
                  size="md"
                />
              </div>
            </div>
          </li> */}
        </ul>
      </div>
    </div>
  );
}

export default Stashboard;
